import { SVGProps } from 'react'
const EqualsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M19 10H5V8h14v2m0 6H5v-2h14v2Z" />
  </svg>
)
export default EqualsIcon
